import {
  Chip,
  Typography,
  Box
} from "@material-ui/core";
import theme from  "../../theme";

export default function RegistrationMethodChip({ value }) {
  const map = {
    SELF_REGISTRATION: {
      label: "Self Registered",
      bg: "#ECF3FF",
      color: "#3E83FB",
      border: "#C5DAFE",
      dotColor: "#3E83FB",
    },
    INVITATION: {
      label: "Invited",
      bg: "#F0FDF4",
      color: "#16A34A",
      border: "#BBF7D0",
      dotColor: "#78F49E",
    },
  };

  const config = map[value] ?? {
    label: value ?? "—",
    bg: "#F5F6F7",
    color: "#8892a4",
    border: "#EAEAEA",
    dotColor: "#C4C9D4",
  };

  return (
    <Chip
      size="small"
      label={
        <Box style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <Box
            style={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: config.dotColor,
              flexShrink: 0,
            }}
          />
          {config.label}
        </Box>
      }
      style={{
        background: config.bg,
        color: config.color,
        border: `1.5px solid ${config.border}`,
        fontFamily: theme.fontFamily.MARKPROBOLD,
        fontSize: 11.5,
        height: 24,
      }}
    />
  );
}